import styled from 'styled-components';

import Row from 'components/Row';

const Column = styled(Row)`
  flex-direction: column;
`;

export default Column;
